import React, { useRef, useState } from "react";
import { api } from "../actions/api";
import { useNavigate } from "react-router-dom";

const HistoryTable = ({
  data,
  loading,
  pagination,
  onPageChange,
  onDeleteRequest,
  selectedIds,
  onRowSelect,
  onSortChange,
  currentSort,
}) => {
  const handlePaginationChange = (page) => {
    if (page > 0 && page <= pagination.last_page) {
      onPageChange(page);
    }
  };
  const navigate = useNavigate();
  const modalref = useRef(null);
  const [assessmentDetails, setAssessmentDetails] = useState([]);

  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const visibleIds = data.map((item) => item.id);
    onRowSelect(visibleIds, isChecked);
    setSelectAll(isChecked);
  };
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);

  const allSelected = data.length > 0 && selectedIds.length === data.length;

  const handleShareClick = async (id) => {
    try {
      const response = await api.get(`/user/assessments/details`, {
        params: {
          user_assessment_score_id: id,
        },
      });


      setAssessmentDetails(response.data.data);
      setShowAssessmentModal(true);
    } catch (err) {
      console.error("Error fetching assessments:", err);
    }
  };

  const handleAssessmentClick = (id, status, assessment_id) => {
    if (status === "not-completed") {
      navigate("/assessment-view", {
        state: {
          id: assessment_id,
          incomplete_id: id,
          assessment_status: status,
        },
      });
    } else {
      navigate("/assessment-view/completed", { state: { id: [id] } });
    }
  };

  // //sort
  // const getSortIcon = (column) => {
  //   if (currentSort.sort_by !== column) {
  //     return "/icons/table-sort.svg";
  //   }
  //   return currentSort.sort_order === "asc"
  //     ? "/icons/table-sort-asc.svg"
  //     : "/icons/table-sort-desc.svg";
  // };
  return (
    <div className="table-responsive">
      {loading ? (
        <div className="text-center py-5">
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        </div>
      ) : (
        <>
          <table className="table table-borderless history-table">
            <thead>
              <tr>
                <th>
                  <label className="custom-checkbox">
                    <input
                      className="hidden-checkbox"
                      type="checkbox"
                      checked={allSelected}
                      onChange={handleSelectAll}
                    />{" "}
                    <span className="table-checkbox">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.59741 5.99891L5.02797 8.42947L9.88908 3.56836"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </label>
                </th>
                <th className="text-body-b1">
                  <div
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSortChange("assessment_date")}
                  >
                    Date
                    <img
                      className="ms-2"
                      src="/icons/table-sort.svg"
                      alt="sort"
                    />
                  </div>
                </th>
                <th className="text-body-b1">
                  <div
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSortChange("assessment_name")}
                  >
                    Name
                    <img
                      className="ms-2"
                      src="/icons/table-sort.svg"
                      alt="sort"
                    />
                  </div>
                </th>
                <th className="text-body-b1">
                  <div
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSortChange("score")}
                  >
                    Score
                    <img
                      className="ms-2"
                      src="/icons/table-sort.svg"
                      alt="sort"
                    />
                  </div>
                </th>
                <th className="text-body-b1">
                  Actions
                  {/* <img
                    className="ms-2"
                    src="/icons/table-sort.svg"
                    alt="sort"
                  /> */}
                </th>
              </tr>
            </thead>
            <tbody>

              {data.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    No history records found
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="custom-checkbox">
                        <input
                          className="hidden-checkbox"
                          type="checkbox"
                          checked={selectedIds.includes(item.id)}
                          onChange={(e) =>
                            onRowSelect(item.id, e.target.checked)
                          }
                        />
                        <span className="table-checkbox">
                          {selectedIds.includes(item.id) && (
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M2.59741 5.99891L5.02797 8.42947L9.88908 3.56836"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </span>
                      </label>
                    </td>
                    <td
                      className={`text-body-b2 ${item.status1}`}
                      onClick={() => {
                        handleAssessmentClick(
                          item.id,
                          item.status1,
                          item.assessment_id,
                        );
                      }}
                      style={{
                        cursor: "pointer",
                        color: item.is_completed
                          ? "var(--Primary-500, #008cff) !important"
                          : "",
                      }}
                    >
                      {item.date}
                    </td>
                    <td className={`text-body-b2 ${item.status1}`}>
                      <div className="table-svg-container">
                        <img
                          src={item.typeIcon}
                          alt="type-icon"
                          width="20"
                          height="20"
                        />
                        <span
                          className="text-truncate"
                          style={{
                            display: "inline-block",
                            maxWidth: "350px",
                            verticalAlign: "middle",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            color: item.is_completed
                              ? "var(--Primary-500, #008cff) !important"
                              : "",
                          }}
                          title={item.type}
                          onClick={() => {
                            handleAssessmentClick(
                              item.id,
                              item.status1,
                              item.assessment_id,
                            );
                          }}
                        >
                          {item.type}
                        </span>
                      </div>
                    </td>
                    <td
                      className={`text-body-b2 ${item.status1}`}
                      style={{
                        color: item.is_completed
                          ? "var(--Primary-500, #008cff) !important"
                          : "",
                      }}
                    >
                      {item.score}
                    </td>
                    <td>
                      <div className="d-flex gap-2 justify-content-end">
                        <img
                          src="/icons/outline-document.svg"
                          alt="document"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleAssessmentClick(
                              item.id,
                              item.status1,
                              item.assessment_id,
                            );
                          }}
                        />
                        <img
                          src="/icons/journal-delete-icon.svg"
                          alt="Delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (item.id) {
                              onDeleteRequest(item.id);
                            } else {
                              console.error(
                                "Cannot delete - no ID found for item:",
                                item,
                              );
                            }
                          }}
                          style={{ cursor: "pointer" }}
                        />
                        <img
                          src="/icons/journal-share-icon.svg"
                          alt="share"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleAssessmentClick(
                              item.id,
                              item.status1,
                              item.assessment_id,
                            );
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {/* pagination */}
          {data.length > 0 && (
            <div className="pagination-container">
              <div>
                <span
                  className="body-2-regular"
                  style={{ marginRight: "20px", color: "#e6ecf1" }}
                >
                  Showing
                </span>
                <select
                  className="text-body-b2"
                  value={pagination.per_page}
                  onChange={(e) => onPageChange(1, parseInt(e.target.value))}
                  style={{
                    background: 'url("/icons/table-arrow-down.svg") no-repeat',
                    backgroundSize: "20px 20px",
                    backgroundPosition: "right 12px center",
                    appearance: "none",
                    borderRadius: "10px",
                    border: "1px solid #1b2c3a",
                    padding: "8px 16px",
                    height: "46px",
                    width: "76px",
                    color: "#d0d8df",
                    backgroundColor: "#121e29",
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                </select>
              </div>

              <span className="body-2-regular" style={{ color: "#e6ecf1" }}>
                Showing{" "}
                {(pagination.current_page - 1) * pagination.per_page + 1} to{" "}
                {Math.min(
                  pagination.current_page * pagination.per_page,
                  pagination.total,
                )}{" "}
                of {pagination.total} records
              </span>

              <nav>
                <ul className="pagination" style={{ gap: "5px" }}>
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() =>
                        handlePaginationChange(pagination.current_page - 1)
                      }
                      disabled={pagination.current_page === 1}
                    >
                      <img
                        src="/icons/pagination-left-icon.svg"
                        alt="previous"
                      />
                    </button>
                  </li>
                  {Array.from(
                    { length: Math.min(5, pagination.last_page) },
                    (_, index) => {
                      let pageNum;
                      if (pagination.last_page <= 5) {
                        pageNum = index + 1;
                      } else if (pagination.current_page <= 3) {
                        pageNum = index + 1;
                      } else if (
                        pagination.current_page >=
                        pagination.last_page - 2
                      ) {
                        pageNum = pagination.last_page - 4 + index;
                      } else {
                        pageNum = pagination.current_page - 2 + index;
                      }

                      return (
                        <li
                          key={index}
                          className={`page-item ${
                            pagination.current_page === pageNum ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePaginationChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        </li>
                      );
                    },
                  )}
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() =>
                        handlePaginationChange(pagination.current_page + 1)
                      }
                      disabled={
                        pagination.current_page === pagination.last_page
                      }
                    >
                      <img src="/icons/pagination-right-icon.svg" alt="next" />
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HistoryTable;
